import './styles/title.css'
export default function Title({content, fadeOut}) {
    return (
        <>
            <div className={`comp-title${fadeOut ? " fade-out" : ""}`}>
                <h1>{content}</h1>
            </div>
        </>
    );
};